// Utility to resolve Atlas backend URLs without leaking environment-specific hosts.

const parts: string[] = new URL(window.location.href).hostname.split('.');
const subdomain: string = parts.length >= 3 ? parts[0] : 'localhost';

const config: Record<string, { apiUrl: string }> = {
  localhost: {
    apiUrl: process.env.REACT_APP_ATLAS_BASE_URL || process.env.REACT_APP_CARTO_BASE_URL || 'http://localhost:8000',
  },
  'atlas-dev-usea2': {
    apiUrl: 'https://atlas-backend-dev-usea2.sandbox.liftango.com',
  },
  atlas: {
    apiUrl: 'https://atlas-backend-prod-apse2.liftango.com',
  },
  'cartographer-dev-usea2': {
    apiUrl: 'https://cartographer-backend-dev-usea2.sandbox.liftango.com',
  },
  'cartographer': {
    apiUrl: 'https://cartographer-backend-prod-apse2.liftango.com',
  },
};

export function getAtlasApiBaseUrl(): string {
  return config[subdomain]?.apiUrl || config['localhost'].apiUrl;
}

export function getSimulationApiBaseUrl(): string {
  return (process.env.REACT_APP_API_BASE_URL || getAtlasApiBaseUrl()).replace(/\/+$/, '');
}
